<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline, mdiPrinter, mdiContentSave } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import * as XLSX from "xlsx"


const props = defineProps({
	//records: Array,
	template: String,
	title: String,
	fileName: String,
	levels: Object,
	classrooms: Object,
	classroomsugel: Object,
	//ciclos: Object,
	isAdmin: Boolean,
	isCoord: Boolean,
	plantilla: String,
	options: Object,
	anioLectivo: String,
	resource: String

});
//let elementsDisabled = getElementsByTagName('input', 'select');
const loading = ref(false)
const resource = ref(props.resource)
const errors = ref({})
const error = ref('')
const filters = {
	'status_ugel': ''
}
const options = {
	'show_activos': true, // deprecated, se usará filers
	'show_retirados': 0,
	'show_compare': 0
}
const form = ref({
	'anio_consulta': props.anioLectivo,
	'fc_anio': '2L',
	'id_level': 0,
	'id_classroom': 0,
	'id_classroom_matricula': 0,
	'id_classroom_ugel': 0,
	'options': options,
	'filters': filters,
	'is_sort_nombre': false,
	'sort_nombre': false,
	'is_sort_puntaje': false,
	'sort_puntaje': false,
	'template': props.template,
	'tipo_aula_consulta': 0
})

const records = ref([])
//const id_classroom = ref(0)
//const ref_ciclo= ref(0)

const getRecords = async () => {
	loading.value = true
	await axios.post(`/${resource.value}/records`, form.value)
		.then(response => {
			records.value = response.data;
		});
	loading.value = false;

	// Renombrar archivo de exportación según datos
	//getTextSelectAula()

	// Convertir vista de lista en otra estructura
	//if (props.template == 'calificationsbymerito') {
		//procesarListado('calificationsbymerito')
	//}
}

const sortNombre = () => {
	form.value.is_sort_nombre = true;
	form.value.is_sort_puntaje = false;
	form.value.sort_nombre = !form.value.sort_nombre;
	getRecords();
}

const exportFile = async (format) => {
	loading.value = true;
	// this.loadingSubmit = true;
	errors.value = {};
	console.log('cr_ugel ' + form.value.id_classroom_ugel)
	console.log('cr ' + form.value.id_classroom)
	console.log('ciclo ' + form.value.ref_ciclo)
	await axios({
		url: `/${resource.value}/export`,
		method: 'POST',
		responseType: 'blob',
		data: {
			'records': records.value,
			'format': format,
			'template': props.template,
			'id_level': form.value.id_level,
			'id_classroom': form.value.id_classroom,
			'id_classroom_ugel': form.value.id_classroom_ugel,
			'id_classroom_matricula': form.value.id_classroom_matricula,
			'anio_consulta': form.value.anio_consulta,
			'options': JSON.stringify(options)
		}
	}).then(response => {
		let res = response.data;
		if (res.type === 'application/json') {
			//this.$message.error('Error al exportar');
			console.log('Error al exportar')
		} else {
			const url = window.URL.createObjectURL(new Blob([res]));
			const link = document.createElement('a');
			link.href = url;
			//link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
			if (format == 'preview') {
				link.target = "_blank";
				link.setAttribute('view', props.fileName + '.html');
			} else {
				link.setAttribute('download', props.fileName + '_' + aulaText.value + '.' + format);
			}
			document.body.appendChild(link);
			link.click();
		}
	}).catch(error => {
		console.log(error);
		errors.value = error;
	}).then(() => {
		loading.value = false;
	});
	// this.loadingSubmit = false;
	//

}

const number2nota = (notaN) => {
	let nota = parseFloat(notaN).toFixed(2);
	let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
	//console.log(nota)
	return result
}

const aulaText = ref('')
const getTextSelectAula = () => {
	if (form.value.id_classroom > 0) {
		var values = props.classrooms.map(function (o) { return o.value }) // <-- Crear una nueva lista con map aplicando una función, antes .id ahora .value
		var index = values.indexOf(form.value.id_classroom)
		//var index = form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel
		aulaText.value = props.classrooms[index].label
	}

	//console.log(index)
	console.log(aulaText.value)

}

/**
 * Estructurar nuevo listado
 */
const nuevoListadoActive = ref(false)
const nuevoListado = ref([])
const procesarListado = (template) => {
	const arrObjs = []; // Array de objetos
	const arr = records.value
	if (template == 'calificationsbymerito') {
		arr.forEach((record, index) => {
			let siexiste = checkExistObject(arrObjs, 'id_student', record.id_student)

			if (siexiste) {
				arrObjs.find(item => item.id_student === record.id_student).total_acumulado += parseInt(record.promediods)
			} else {
				arrObjs.push({
					id_student: record.id_student,
					fullname: record.fullname,
					ref_ciclo: record.ref_ciclo,
					total_acumulado: record.promediods
				});
			}

		});

		// ORdenar objetos según el campo y de mayor a menor (descendente)
		orderList('total_acumulado', 'desc', arrObjs)
	}
	// Agregar más estructuras de templates con else if('') ...

	nuevoListado.value = arrObjs
	if (arrObjs.length) {
		nuevoListadoActive.value = true
	}

	console.log(nuevoListado.value.length)
}

// Si existe el objeto según el atributo en un array de objetos
const checkExistObject = (arrObj, attr, val) => {
	return arrObj.some((obj) => obj[attr] == val)
}

// Ordenar listado
const orderList = (orderfield, sort = '', objs) => {
	objs.sort((a, b) => {
		if (sort == 'asc') {
			return a[orderfield] - b[orderfield]
		} else if (sort == 'desc') {
			return b[orderfield] - a[orderfield]
		} else {
			return a[orderfield] - b[orderfield]
		}
	});
}

// Ordenar listado sólo números no string <---------------
const sortUp = ref(false)
const sortDown = ref(false)
const sortnodefine = ref(false)
const orderColumn = (orderfield, sort = '', objs = nuevoListado.value) => {

	// Si no se define sort
	if (!sort) {
		sortnodefine.value = !sortnodefine.value
		if (sortnodefine.value) {
			sort = 'asc'
			sortUp.value = false
			sortDown.value = true
		} else {
			sort = 'desc'
			sortUp.value = true
			sortDown.value = false
		}
	}

	orderList(orderfield, sort, objs)
	nuevoListado.value = objs
	console.log('ordercolumnchanged')

}

// Calcular puesto
const calcularPuesto = (puesto, lastPuntaje, puntaje) => {
	// Si hay puntajes iguales se repite los puestos, de lo contrario se mantiene el puesto anterior <-- existen puestos duplicados
	if (lastPuntaje != puntaje) {
		puesto++
	}
	console.log(lastPuntaje + ' - ' + puntaje)
	return puesto
}

// Actualizar datos academicos de estudiante
const updateAulaUgel = (id_student, ref_classroom_ugel, index) => {
	let resource = 'student'
	let formSend = {
		'id_student': id_student,
		'anio_consulta': form.value.anio_consulta,
		'ref_classroom_ugel': ref_classroom_ugel
	}

	axios.post(`/${resource}/updateaulaugel`, formSend)
		.then(response => {
			let resp = response.data;
			if (resp.success) {
				buttonUpgrade.value[index] = true
				//buttonUpgrade.value.fill(true, index, index + 1)
				console.log('Upgrade OK ' + id_student + ' - ' + index + ' : ' + resp.message)
				//console.log(buttonUpgrade.value)
			} else {
				messagealert.value[index] = resp.message
			}
		});
}

const file = ref(null)
const fileContent = ref(null)
const dataRows = ref([])
const arrayObjects = ref([])
const refClassRoomUgelFile = ref([])
const validarAnio = ref('')
const buttonUpgrade = ref([])
const messagealert = ref([])

const onChange = (event) => {
	file.value = event.target.files ? event.target.files[0] : null;
	//console.log(file.value)
}
const procesarArchivo = () => {
	validarAnio.value = form.value.anio_consulta
	dataRows.value = []
	arrayObjects.value = []
	refClassRoomUgelFile.value = []
	buttonUpgrade.value = []
	messagealert.value = []
	if (file.value) {
		//loading.value = true;
		//console.log(loading.value)
		fileContent.value = ''
		var txtPreview = false
		// text/plain
		if (!file.value.type.startsWith("text")) {
			//alert('Debe cargar un archivo excel')
			//return
		} else {
			txtPreview = true
		}

		const reader = new FileReader()
		reader.onload = (e) => {
			if (txtPreview) {
				fileContent.value = reader.result
			}
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: 'binary' });
			/* Get first worksheet */
			const wsname = wb.SheetNames[0];
			const ws = wb.Sheets[wsname];
			/* Convert array of arrays */
			const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
			//console.log(data) 
			// declarar arrays
			for(let i=0; i < data.length; i++) {
				getStudent(i, data[i][7], (data.length - 1), data[i][25])
			}
			dataRows.value = data
		}
		reader.onerror = () => {
			alert('Vuelva a cargar el archivo')
			return
		}
		
		reader.readAsBinaryString(file.value);
		
		//file.value = null
		//loading.value = false;
		//console.log(loading.value)
		//console.log(arrayObjects.value)

		//let workbook = XLSX.readFile(file.value);
		//console.log('workbook1');
		//console.log(rowsExcel.value);
		//console.log('SheetNames');
		//console.log(workbook.SheetNames);
	}
}


//arrayObjects.value[0] = {'id': 0, 'apellidos': 'Sin datos'}
const canProcess = ref(true)
const getStudent = (indice, numdoc, lastindice, statusugel = '') => {
    //let url = '/reportstudentupload/getstudent?anio_consulta='+form.value.anio_consulta+'&num_doc='+numdoc;
   /*  await axios.get(url).then((response) => {
        let respuesta = response.data
		console.log(respuesta)
        //data = response.data
    }).catch((error) => {
        console.log(error);
    }); */
	if (indice == 0) {
		loading.value = true
	}
	let resource = 'student'
	
	var data = {}
	data['id'] = 0
	data['apellidos'] = 'No existe en la base de datos'
	
	let formSend = {
		'anio_consulta': form.value.anio_consulta,
		'num_doc': numdoc
	}
	
	axios.post(`/${resource}/getstudent`, formSend)
	.then(response => {
		let resp = response.data;
		console.log(resp)
		if (resp.error) {
			data['id'] = 0
			data['apellidos'] = resp.message
			arrayObjects.value[indice] = data

			// Students
			if (indice > 11) {
				arrayNoexist.value.push(indice)
			}
		} else {
			data = resp.data
			arrayObjects.value[indice] = data

			// Students
			if (indice > 11) {
				if (statusugel == 'DEFINITIVA') {
					arrayDefinitiva.value.push(data['id'])
				} else if (statusugel == 'TRASLADADO') {
					arrayTrasladado.value.push(data['id'])
				} else if (statusugel == 'EN PROCESO') {
					arrayEnProceso.value.push(data['id'])
				}
			}
		}

		// si es el útlimo entonces cerrar loader
		if (indice == lastindice) {
			loading.value = false
			canProcess.value = false
			//file.value.value = null
			//console.log(lastindice)
		}
	});
	
	
	//arrayObjects.value[indice] = data
	//return data
}

// Click a botón de actualizar en verde cuando se aplique
const updateAll = () => {
    let buttons = document.getElementsByName('buttonupdateline');
    //let count = 0
    //let lastIt = buttons.length - 1
	loading.value = true
    for (let i = 0; i < buttons.length; i++) {
		if (i == 0) {
			loading.value = true
		}
        buttons[i].click();
		if (i == (buttons.length - 1)) {
			loading.value = false
		}
    }
	loading.value = false
}

const arrayNoexist = ref([]) // Students que no exist in the system
const arrayTrasladado = ref([])
const arrayDefinitiva = ref([])
const arrayEnProceso = ref([])
const msgScUpdateStatus = ref('')
const msgErUpdateStatus = ref('')
const updateStatusSelect = ref('DEFINITIVA')
const updateStatus = (statusugel) => {
	let statussystem = 1
	let arStudents = []
	if (statusugel == 'DEFINITIVA') {
		statussystem = 1
		arStudents = arrayDefinitiva.value
	} else if (statusugel == 'TRASLADADO') {
		statussystem = 0
		arStudents = arrayTrasladado.value
	} else if (statusugel == 'EN PROCESO') {
		statussystem = 1
		arStudents = arrayEnProceso.value
	}

	let resource = 'student'
	let formSend = {
		'students': arStudents,
		'anio_consulta': form.value.anio_consulta,
		'estado_ugel': statussystem
	}

	axios.post(`/${resource}/updatestatusugel`, formSend)
		.then(response => {
			let resp = response.data;
			if (resp.success) {
				console.log('Status Ugel: ' + statusugel + ' Sistema: ' + statussystem)
				console.log(arStudents)
				msgScUpdateStatus.value = resp.message
				//console.log(buttonUpgrade.value)
			} else {
				msgErUpdateStatus.value = resp.message
			}
		});

}

const showAyuda = ref([
    { 'excelstudent': false },
    { 'silabo': false }
])
</script>

<template>
	<Head title="Comparar Planilla Ugel" />

	<BreezeAuthenticatedLayout>
		<template #header>
        <PremiumPageHeader title="{{ title }}" subtitle="Gestión de {{ title }}">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
            </template>
        </PremiumPageHeader>
    </template>

		<div>
			<!-- Loader -->
			<div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
				<!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
				<div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
				<p class="text-rose-600">Procesando ...</p>
				<!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
			</div>
			<div><!--max-w-7xl-->
				<div class="bg-white rounded-md shadow-lg p-4 border" :class="loading ? 'pointer-events-none' : ''">

					<div class="mb-4 text-center">
						Año
						<input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
					</div>

					<div class="grid gap-3 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 mb-4">
						<!-- <div class="col-span-1">
							<label class="block font-bold ">Nivel/Grado</label>
							<select v-model="form.id_level" class="w-full">
								<option value="0" selected></option>
								<option v-for="option in levels" :value="option.value">{{ option.label }}</option>
							</select>
						</div> -->
						<template class="block">
							<label for="tipo_aula_consulta" class="select mb-2 ml-2">Aula registrada al estudiante</label>
							<select v-model="form.tipo_aula_consulta" id="tipo_aula_consulta" class="ml-2">
								<option value="0">Aula matrícula</option>
								<option value="1">Aula de estudio</option>
							</select>
						</template>
						
					</div>

					<div class="flex flex-wrap gap-3"> <!-- v-if="records.length" -->
						<!-- <div v-if="nuevoListado.length" class="inline-block">
							<BaseButton :disabled="records.length <= 0 || loading" @click="nuevoListadoActive = !nuevoListadoActive" color="warning" :icon="mdiFileTableOutline" :label="nuevoListadoActive ? 'Ver detalle de lista' : 'Ver lista original'" small />
						</div> -->
						<div class="inline-block">
							<BaseButton @click="getRecords()" color="danger" :icon="mdiFileTableOutline" label="Procesar" small />
						</div>
						<!-- More buttons -->
						<!-- <div class="inline-block">
						<BaseButton
							@click="getRecords()"
							color="danger"
							:icon="mdiFileTableOutline"
							label="Procesar"
							small
							/>
						</div> -->

					</div>
					<!-- <div class="mt-6">Total {{ dataRows.length }}</div> -->
					<br>
					<hr class="mt-2 mb-2">
					<br>

					<CardBox v-if="records" class="mb-6" has-table>
						<div class="w-full overflow-x-auto">
							<!-- Listado Original -->
							<table class="table-responsive">
								<thead>
									<tr>
										<th>#</th>
										<th>Aula {{ form.anio_consulta ? parseInt(form.anio_consulta) - 1 : parseInt(confGlobal.value.CICLO_ANIO_ESCOLAR) - 1 }}</th>
										<th>Total</th>
										<th>Nuevos</th>
										<th>Antiguos</th>
										<th>Retirados (en el año)</th>
										<th>Cantidad de estudiantes que terminaron</th>
										<th>Aula {{ form.anio_consulta ? form.anio_consulta : confGlobal.value.CICLO_ANIO_ESCOLAR }}</th>
										<th>Total</th>
										<th>Nuevos</th>
										<th>Antiguos</th>
										<th>Retirados (promovidos que se trasladaron)</th>
										<th>Promovidos (no matriculados)</th>
										<!-- <th>Deudores</th> -->
									</tr>
								</thead>
								<tbody :set="ite = 0">
									<tr v-for="(row, index) in records" :key="row.id">
										<td data-label="#">
											{{ (ite + 1) }}
										</td>
										<td data-label="Aula" >
											{{ (index ? index : 'Aula no asignada') }}
										</td>
										<td data-label="Total" >
											{{ row.old.total }}
										</td>
										<td data-label="Nuevos" >
											{{ row.old.nuevos }}
										</td>
										<td data-label="Antiguos" >
											{{ row.old.antiguos }}
										</td>
										<td data-label="Retirados" >
											{{ row.old.retirados }}
										</td>
										<td data-label="Cantidad de estudiantes promovidos" >
											{{ row.old.activos }}
										</td>
										<td data-label="Aula" >
											{{ (index ? index : 'Aula no asignada') }}
										</td>
										<td data-label="Total" >
											{{ row.now.total }}
										</td>
										<td data-label="Nuevos" >
											{{ row.now.nuevos }}
										</td>
										<td data-label="Antiguos" >
											{{ row.now.antiguos }}
										</td>
										<td data-label="Retirados (promovidos que se trasladaron)" >
											{{ row.now.retirados }}
										</td>
										<td data-label="Promovidos (no matriculados)" >
											{{ row.now.promovidos }}
										</td>
										<!-- <td data-label="Deudores" >
											{{ row.now.deudores }}
										</td> -->
										<span v-show="false" :set="ite++"></span>
									</tr>
								</tbody>
							</table>
							
						</div>
					</CardBox>
					<CardBox v-else>
						<CardBoxComponentEmpty />
					</CardBox>
					
				</div>
			</div>
		</div>
	</BreezeAuthenticatedLayout>
</template>